import { t } from "ttag";

import type { Subscription } from "@/features/billing/models";
import { useConsultationStore } from "@/features/consultations/contexts";
import { HealthieForm } from "@/features/intake-form/components";
import { Button } from "@/shared/ui";
import { APPOINTMENT_TYPE } from "../models";

interface HealthieFormProps {
  subscription: Subscription;
  onCancel: VoidFunction;
  onSubmit: VoidFunction;
}

export const VideoConsultationFormSection = ({
  subscription,
  onCancel,
  onSubmit,
}: HealthieFormProps) => {
  const appointmentType = useConsultationStore(
    (state) => state.appointmentType,
  );

  const productId =
    appointmentType === APPOINTMENT_TYPE.OTHER ? null : subscription.product.id;

  return (
    <HealthieForm
      onSubmit={onSubmit}
      params={{
        isAsync: false,
        isRefill: true,
        withRefill: false,
        productId,
      }}
      className="max-w-none"
    >
      <div className="flex flex-col-reverse items-stretch justify-between gap-4 md:flex-row md:items-center">
        <Button onClick={onCancel} variant="secondary" size="lg">
          {t`Back`}
        </Button>
        <Button type="submit" size="lg">
          {t`Next`}
        </Button>
      </div>
    </HealthieForm>
  );
};
